import React from 'react';
import classes from './HorHeader.module.css';
import { Link } from "react-router-dom"
import avatar from '../../Assets/Avatar.png'
import notify from '../../Assets/notify.png'

const HorHeader = () => {
    return (
        <div className={classes.body}>
            <div className={classes.bdycontainer}>
                <div>
                    <p className={classes.horptag}>Posts</p>
                </div>
                <div className={classes.rightdtls}>
                    <img src={notify} className={classes.notify} />
                    <p className={classes.ace}>William Oharisi</p>
                    <img src={avatar} className={classes.avatar} />
                </div>
            </div>
        </div>
    );
}

export default HorHeader;
